import View from "../framework/view";
import Server from "../server";
import {LogoutNotification} from "./talc";
import template from "../../pugc/logout";

export class LogoutView extends View {

    static classname = "logout-view";

    constructor() {
        super(LogoutView.classname);
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {};

        const out = this.pug(template, data);
        return out;
    }

    logout() {
        Server.instance().logout()
            .finally(() => {

                const nav = new LogoutNotification();
                this.notify(nav);
            });
    }

}

View.on(
    "." + LogoutView.classname,
    "click",
    ".logout",
    function(that: LogoutView, event, elt) {
        event.preventDefault();
        that.logout();
    });



